module.exports = __webpack_public_path__ + "static/media/img-1.4716ea42.png";